export default __webpack_public_path__ + "static/media/StairRight.256.4a5920a0.png";